import { useMutation } from '@apollo/client'
import {
  AuthEmailPasswordMutation,
  AuthEmailPasswordMutationVariables,
} from 'src/generated'

import MUTATION from './mutation.gql'

export const useAuthEmailPasswordMutation = () =>
  useMutation<AuthEmailPasswordMutation, AuthEmailPasswordMutationVariables>(
    MUTATION,
    {
      fetchPolicy: 'no-cache',
      context: {
        anonymous: true,
      },
    },
  )
